/**
 * Opens the existing disclaimer popup until the visitor accepts it.
 */
(function () {
  'use strict';

  var cookieName = 'disclaimer_agreed';
  var cookieLifetime = 60 * 60 * 24 * 3;

  function hasCookie(name) {
    return document.cookie.split('; ').some(function (cookie) {
      return cookie.indexOf(name + '=') === 0;
    });
  }

  function setCookie(name, value, maxAge) {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
  }

  function openDisclaimerPopup() {
    var trigger = document.createElement('a');
    var originalUrl = window.location.href;

    trigger.href = '#disclaimer-open';
    trigger.hidden = true;
    trigger.setAttribute('aria-hidden', 'true');

    document.body.appendChild(trigger);
    trigger.click();
    trigger.remove();

    window.setTimeout(function () {
      window.history.replaceState(window.history.state, document.title, originalUrl);
    }, 0);
  }

  function showDisclaimerWhenReady() {
    window.setTimeout(function () {
      if (!hasCookie(cookieName)) {
        openDisclaimerPopup();
      }
    }, 250);
  }

  function init() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('#disclaimer-button-agreed');

      if (button) {
        setCookie(cookieName, '1', cookieLifetime);
      }
    });

    if (!hasCookie(cookieName)) {
      if (document.readyState === 'complete') {
        showDisclaimerWhenReady();
      } else {
        window.addEventListener('load', showDisclaimerWhenReady, { once: true });
      }
    }
  }

  init();
})();
